<template>
  <div
    class="relative z-0 overflow-y-auto overflow-x-hidden break-words rounded-lg transition-colors"
    :class="{
      'shadow-xl': elevation === 'high',
      'bg-blue-100': variant === 'primary-light',
      'border border-app-primary bg-white': variant === 'primary',
      'bg-red-50': variant === 'danger-light',
      'border border-grey-200 bg-white shadow-elevated': variant === 'default',
      'border border-app-danger': variant === 'danger',
      'border border-grey-400 bg-white': variant === 'grey',
    }"
  >
    <slot />

    <div
      v-if="$slots.footer || $slots['footer-content']"
      class="sticky bottom-0 z-10 flex w-full justify-end rounded-b-[inherit] bg-white"
    >
      <slot name="footer">
        <div class="px-6">
          <slot name="footer-content" />
        </div>
      </slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  variant?:
    | 'default'
    | 'primary-light'
    | 'primary'
    | 'danger-light'
    | 'danger'
    | 'grey';
  elevation?: 'default' | 'high' | 'none';
}

withDefaults(defineProps<Props>(), {
  variant: 'default',
  elevation: 'none',
});
</script>
